import { CommonSellerService } from '@savgroup-front-common/core/api/Seller/CommonSellerService';

import activateAdvancedPricingPlanCommand from './activateAdvancedPricingPlanCommand';
import { activateFreePricingPlanCommand } from './activateFreePricingPlanCommand';
import { addShopifyIntegrationCommand } from './addShopifyIntegrationCommand';
import checkAdapterStatusQuery from './checkAdapterStatusQuery';
import {
  deleteConfiguredPartnerCommand,
  getConfiguredPartnersQuery,
  getConnectedPartnersQuery,
  upsertConfiguredPartnerCommand,
  upsertConnectedPartnerCommand,
} from './connectedPartner';
import { createSellerCommand } from './createSellerCommand';
import createShippingBoTokenCommand from './createShippingBoTokenCommand';
import deleteAdapterConfiguration from './deleteAdapterConfiguration';
import deleteServiceBusConfiguration from './deleteServiceBusConfiguration';
import getAdapterConfiguration from './getAdapterConfiguration';
import { getAvailableCountriesQuery } from './getAvailableCountriesQuery';
import { getConsoleConfigurationQuery } from './getConsoleConfigurationQuery';
import { getConsoleEntriesVisibilityQuery } from './getConsoleEntriesVisibilityQuery';
import { getConsoleFullConfigurationQuery } from './getConsoleFullConfigurationQuery';
import { getConsoleRestrictedColumnsQuery } from './getConsoleRestrictedColumnsQuery';
import { getRefundMethodsBySellerQuery } from './getRefundMethodsBySellerQuery';
import getSellerBillingConfigurationQuery from './getSellerBillingConfigurationQuery';
import getSellerConfigurationAgoraQuery from './getSellerConfigurationAgoraQuery';
import getSellerConfigurationById from './getSellerConfigurationById';
import { getSellerConfigurationSalesforceQuery } from './getSellerConfigurationSalesforceQuery';
import getSellerIntegrationStatusQuery from './getSellerIntegrationStatusQuery';
import getServiceBusConfiguration from './getServiceBusConfiguration';
import { getVatRateBySellerIdsQuery } from './getVatRateBySellerIdsQuery';
import { pushToProductionCommand } from './pushToProductionCommand';
import cancelSanityTest from './sanityTest/cancelSanityTest';
import getSanityTestsList from './sanityTest/getSanityTestsList';
import startNewSanityTest from './sanityTest/startNewSanityTest';
import { getSellersQuery } from './sellers/getSellersQuery';
import getSellerSummaryById from './sellers/getSellerSummaryById';
import { unsubscribePricingPlanCommand } from './sellers/unsubscribePricingPlanCommand';
import setAdapterConfiguration from './setAdapterConfiguration';
import setSellerBillingConfigurationQuery from './setSellerBillingConfigurationQuery';
import setSellerConfigurationAcceptedLanguagesCommand from './setSellerConfigurationAcceptedLanguagesCommand';
import setSellerConfigurationAccountManagerCommand from './setSellerConfigurationAccountManagerCommand';
import setSellerConfigurationAgoraCommand from './SetSellerConfigurationAgoraCommand';
import setSellerConfigurationOtherCommand from './setSellerConfigurationOtherCommand';
import { setSellerConfigurationSalesforceCommand } from './setSellerConfigurationSalesforceCommand';
import setSellerConfigurationTransportCommand from './setSellerConfigurationTransportCommand';
import { setSellerPricingPlanCommand } from './setSellerPricingPlanCommand';
import setServiceBusConfiguration from './setServiceBusConfiguration';
import setSetSellerConfigurationStripeAccountPublicKey from './setSetSellerConfigurationStripeAccountPublicKey';
import uploadThemeFileCommand from './uploadThemeFileCommand';
import { UpsertConsoleEntryVisibilityCommand } from './UpsertConsoleEntryVisibilityCommand';
import { UpsertConsoleRestrictedColumnsCommand } from './UpsertConsoleRestrictedColumnsCommand';
import upsertSellerCommand from './upsertSellerCommand';

export const SellerService = {
  upsertSellerCommand,
  createSellerCommand,
  getAvailableCountriesQuery,
  getSellersQuery,
  getSellerConfigurationSalesforceQuery,
  setSellerConfigurationSalesforceCommand,
  cancelSanityTest,
  getSanityTestsList,
  startNewSanityTest,

  getSellerSummaryById,
  getSellerConfigurationById,
  setSetSellerConfigurationStripeAccountPublicKey,
  uploadThemeFileCommand,

  getServiceBusConfiguration,
  deleteServiceBusConfiguration,
  setServiceBusConfiguration,
  getAdapterConfiguration,
  deleteAdapterConfiguration,
  setAdapterConfiguration,
  setSellerPricingPlanCommand,
  setSellerConfigurationAcceptedLanguagesCommand,
  setSellerConfigurationAccountManagerCommand,
  setSellerConfigurationOtherCommand,
  setSellerConfigurationTransportCommand,

  getConsoleEntriesVisibilityQuery,
  getConsoleRestrictedColumnsQuery,
  UpsertConsoleRestrictedColumnsCommand,
  UpsertConsoleEntryVisibilityCommand,
  getConsoleConfigurationQuery,
  getConsoleFullConfigurationQuery,
  getRefundMethodsBySellerQuery,
  getSellerBillingConfigurationQuery,
  setSellerBillingConfigurationQuery,
  getSellerIntegrationStatusQuery,
  createShippingBoTokenCommand,
  checkAdapterStatusQuery,

  addShopifyIntegrationCommand,
  pushToProductionCommand,
  unsubscribePricingPlanCommand,
  setSellerConfigurationAgoraCommand,
  getSellerConfigurationAgoraQuery,
  getConnectedPartnersQuery,
  getConfiguredPartnersQuery,
  upsertConnectedPartnerCommand,
  upsertConfiguredPartnerCommand,
  deleteConfiguredPartnerCommand,
  activateFreePricingPlanCommand,
  getVatRateBySellerIdQuery: CommonSellerService.getVatRateBySellerIdQuery,
  getVatRateBySellerIdsQuery,

  activateAdvancedPricingPlanCommand,
};
